/**
 * 全局常量 命名风格:首字母大写驼峰式
 */
import { CreditConsumptionType, CreditChangeType } from '@/types/constantsEnum'
import { AgreementType, CategoryEnum } from '@/types/constantsEnum'
export const ResourceUrl = import.meta.env.VITE_APP_RESOURCE_URL
export const Constants = {
  ProgressColors: [
    { color: '#A5CBF7', percentage: 20 },
    { color: '#47CDF3', percentage: 40 },
    { color: '#47CDF3', percentage: 60 },
    { color: '#47CDF3', percentage: 80 },
    { color: '#47CDF3', percentage: 100 },
  ],
}
export const PhoneRegexMap = [
  {
    number: '86',
    country: '中国',
    regex: '^(\\+?86|\\+?0086)1[3456789]\\d{9}$',
  },
  { number: '886', country: '中国台湾', regex: '^(\\+?886)0?9\\d{8}$' },
  {
    number: '852',
    country: '中国香港',
    regex: '^(\\+?852\\-?)[569]\\d{3}\\-?\\d{4}$',
  },
  { number: '853', country: '中国澳门', regex: '^(853)?6d{7}$' },
  {
    number: '1',
    country: '美国',
    regex: '^(\\+?1)[-]?\\(?(\\d{3})\\)?[-]?(\\d{3})[-]?(\\d{4})$',
  },
  { number: '44', country: '英国', regex: '^(\\+?44)?7\\d{9}$' },
  {
    number: '49',
    country: '德国',
    regex:
      '^(\\+?49[\\.\\-])([\\(]{1}[0-9]{1,6}[\\)])?([0-9\\.\\-\\/]{3,20})((x|ext|extension)[ ]?[0-9]{1,4})?$',
  },
  {
    number: '60',
    country: '马来西亚',
    regex: '^(\\+?6?01)(([145]{1}(\\-|\\s)?\\d{7,8})|([236789]{1}(\\s|\\-)?\\d{7}))$',
  },
  { number: '61', country: '澳大利亚', regex: '^(\\+?61|0)4\\d{8}$' },
  { number: '64', country: '新西兰', regex: '^(\\+?64)2\\d{7,9}$' },
  { number: '65', country: '新加坡', regex: '^(\\+?0?65\\-?)\\d{10}$' },
  { number: '66', country: '泰国', regex: '^(\\+?0?66\\-?)\\d{10}$' },
  {
    number: '81',
    country: '日本',
    regex: '^(\\+?81)\\d{1,4}[\\-]?\\d{1,4}[\\-]?\\d{4}$',
  },
  { number: '82', country: '韩国', regex: '^(\\+?82)01[016789](\\d{8})$' },
  { number: '91', country: '印度', regex: '^(\\+?91)[789]\\d{9}$' },
  { number: '855', country: '柬埔寨', regex: '^(\\+?855)\\d{6,9}$' },
]

// 登录账号类型
export const LoginAccountType = {
  Email: 1,
  Phone: 2,
  WeiXin: 3,
}

// 登录密码类型
export const LoginPasswordType = {
  Password: 1,
  Code: 2,
}

// 登录页面类型
export const LoginPageType = {
  emailLogin: 0, //邮箱登陆
  phoneLogin: 1, //手机登陆
  weixinLogin: 2, //微信二维码登陆
  register: 3, //注册
  forget: 4, //忘记密码
  emailRegister: 5, //邮箱注册
  phoneRegister: 6, //手机注册
  emailVerifyCode: 7, //邮箱验证码
  phoneVerifyCode: 8, //手机验证码
}

// 历史登录类型
export const HistoryLoginType = {
  emailLogin: 0, //邮箱登陆
  phoneLogin: 1, //手机登陆
  weixinLogin: 2, //微信二维码登陆
}

export const historyLoginInfo = {
  historyLoginType: HistoryLoginType,
  account: '',
}
// 人生克隆
export const LifeCloneUploadType = {
  Operate: 0, //未操作
  Upload: 1, //上传
  Asset: 2, //素材库
  Record: 3, //录制
  StartLayer: 4, //上传、素材库、录制成功
  Success: 5, //训练结束
  ComplexOperate: 6, //复杂模型操作
}

// 人生克隆操作步骤
export const LifeCloneStep = {
  step0: 0, //未操作
  step1: 1, //填写项目信息
  step2: 2, //上传歌曲样本
  step3: 3, //开始AI训练
  step4: 4, //训练结束
}

// 训练模型类型
export const VoiceModelType = {
  Simple: 1, //简单模型
  Complex: 2, //复杂模型
}

// 收藏状态
export const FavoriteType = {
  favorite: true, //收藏
  unFavorite: false, //取消收藏
}
export const PayChannel = {
  WEIXIN: 1,
  ZHIFUBAO: 2,
}

export const OrderStatus = {
  PENDING: 0, //待支付
  SUCCESS: 1, //已支付
  CANCEL: 2, //已取消
  REFUND: 3, //已退款
}

export const UserGender = {
  male: '男',
  female: '女',
  unknown: '未知',
}

export const TaskStatus = {
  NOT_STARTED: 0, // 未开始
  IN_PROGRESS: 1, // 进行中
  COMPLETED: 2, // 已完成
  FAILED: 3, // 错误
  ENDED: 4, // 失败
  USER_SELECTED: 5, // 用户选择
  API_SERVER_ERROR: 6, // api服务错误
  AUDITING: 7, // 审核中
}

export const CreditChangeTypeMap: Record<CreditChangeType, string> = {
  [CreditChangeType.VOICE_CLONE_FAST]: '基础声音克隆',
  [CreditChangeType.VOICE_CLONE_TRAINED]: '高级声音克隆',
  [CreditChangeType.MUSIC_CREATION]: 'AI音乐创作',
  [CreditChangeType.VOICE_TRANSFORM_FAST]: 'AI演唱基础声线',
  [CreditChangeType.VOICE_TRANSFORM_TRAINED]: 'AI演唱高级声线',
  [CreditChangeType.VOICE_TRANSFORM_MUSIC_REMIX]: '音量 & 声效调整',
  [CreditChangeType.BUY_CREDIT]: '充值',
  [CreditChangeType.FREE_CREDIT]: '免费',
  [CreditChangeType.ADMIN_ADD_CREDIT]: '平台赠送',
  [CreditChangeType.NEW_USER_REGISTER]: '新用户注册',
  [CreditChangeType.INVITE_USER]: '邀请注册',
  [CreditChangeType.INVIATE_USER_REBATE]: '邀请返佣',
}

// 协议名称
export const AgreementName: Record<AgreementType, string> = {
  [AgreementType.Privacy]: '隐私协议',
  [AgreementType.Protocal]: '用户协议',
  [AgreementType.ServiceAgreement]: '生成服务协议',
  [AgreementType.AudioSourceAgreement]: '声源合法授权声明书',
  [AgreementType.CompanyProfile]: '公司简介',
  [AgreementType.CompanyPartners]: '合作伙伴',
}

// 系统分类配置
export const SystemCategoryConfig: Record<
  CategoryEnum,
  {
    category: string
    name: string
    text: string
  }
> = {
  [CategoryEnum.UNIVERSAL_VERIFICATION_CODE]: {
    category: 'universal_verification_code',
    name: 'UNIVERSAL_VERIFICATION_CODE',
    text: '万能验证码',
  },
  [CategoryEnum.REQUIRED_INVITE_CODE]: {
    category: 'required_invite_code',
    name: 'REQUIRED_INVITE_CODE',
    text: '邀请码要求',
  },
  [CategoryEnum.VERIFICATION_CODE_EXPIRATION_TIME]: {
    category: 'verification_code_expiration_time',
    name: 'VERIFICATION_CODE_EXPIRATION_TIME',
    text: '验证码过期时间',
  },
  [CategoryEnum.CREATE_VIDEO_TEXT_MIN]: {
    category: 'create_video_text_min',
    name: 'CREATE_VIDEO_TEXT_MIN',
    text: '合成视频文字最低长度',
  },
  [CategoryEnum.CREATE_VIDEO_TEXT_MAX]: {
    category: 'create_video_text_max',
    name: 'CREATE_VIDEO_TEXT_MAX',
    text: '合成视频文字最高长度',
  },
  [CategoryEnum.BACKGROUND_GROUP]: {
    category: 'background_group',
    name: 'BACKGROUND_GROUP',
    text: '背景图',
  },
  [CategoryEnum.GPT_INIT_COUNT]: {
    category: 'gpt_init_count',
    name: 'GPT_INIT_COUNT',
    text: '未付费用户初始次数',
  },
  [CategoryEnum.COMMON]: {
    category: 'common',
    name: 'COMMON',
    text: '通用',
  },
  [CategoryEnum.OPEN_INVITE]: {
    category: 'open_invite',
    name: 'OPEN_INVITE',
    text: '开通邀请机制',
  },
  [CategoryEnum.INVITE_CHATGPT]: {
    category: 'invite_chatgpt',
    name: 'INVITE_CHATGPT',
    text: '开通邀请机制',
  },
  [CategoryEnum.INVITE_CHATGPT_REGISTER]: {
    category: 'invite_chatgpt_register',
    name: 'INVITE_CHATGPT_REGISTER',
    text: '注册奖励',
  },
  [CategoryEnum.IMG_GROUP]: {
    category: 'img_group',
    name: 'IMG_GROUP',
    text: '系统图片',
  },
  [CategoryEnum.VIDEO_GROUP]: {
    category: 'video_group',
    name: 'VIDEO_GROUP',
    text: '系统视频',
  },
  [CategoryEnum.UN_LIMIT_DIGITAL_COUNT]: {
    category: 'un_limit_digital_count',
    name: 'UN_LIMIT_DIGITAL_COUNT',
    text: '公众号AppId和AppSecret',
  },
  [CategoryEnum.WX_PAY]: {
    category: 'wx_pay',
    name: 'WX_PAY',
    text: '公众号AppId和AppSecret',
  },
  [CategoryEnum.WX_MINI_PROGRAM]: {
    category: 'wx_mini_program',
    name: 'WX_MINI_PROGRAM',
    text: '新增小程序配置类型',
  },
  [CategoryEnum.REGISTER_IS_CLOSE]: {
    category: 'register_is_close',
    name: 'REGISTER_IS_CLOSE',
    text: '注册是否关闭',
  },
  [CategoryEnum.CREDIT_CONSUMPTION]: {
    category: 'credit_consumption',
    name: 'CREDIT_CONSUMPTION',
    text: '积分消费',
  },
  [CategoryEnum.CREDIT_PACK_RATIO]: {
    category: 'credit_pack_ratio',
    name: 'CREDIT_PACK_RATIO',
    text: '积分套餐比例',
  },
  [CategoryEnum.PAY_CONFIG]: {
    category: 'pay_config',
    name: 'PAY_CONFIG',
    text: '支付配置',
  },
}

export const NoticeType = {
  // 新闻
  NEWS: {
    label: '新闻',
    value: 1,
  },
  // 公告
  NOTICE: {
    label: '公告',
    value: 2,
  }, // 产品更新
  PRODUCT_UPDATE: {
    label: '产品更新',
    value: 3,
  },
}
export const CustomType = {
  /**
   * 高级定制轻奢版
   */
  CUSTOM_LITE: 'CUSTOM_LITE',
  /**
   * 高级定制高品质版
   */
  CUSTOM_HQ: 'CUSTOM_HQ',
  /**
   * 高级定制大师版
   */
  CUSTOM_MASTER: 'CUSTOM_MASTER',
  /**
   * 高级定制电影级
   */
  CUSTOM_FILMIC: 'CUSTOM_FILMIC',
}

export const DefaultWaitTime = '5分钟~1小时'
